import { render, staticRenderFns } from "./VesselsGrid.vue?vue&type=template&id=ee455e22&"
import script from "./VesselsGrid.vue?vue&type=script&lang=js&"
export * from "./VesselsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports